import { autoMount } from '../../../utils/autoMount';
import { RecruitmentShowContentFollow } from '../../../components/molecules/recruitmentShowContentFollow';

autoMount({ RecruitmentShowContentFollow });

// TODO: moleculesだけどいいのか